import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcVolumeoffFillWhiteshadow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.158 2.707c.803-.73 2.092-.16 2.092.925v16.736c0 1.086-1.29 1.656-2.092.925l-4.476-4.078a.25.25 0 0 0-.17-.065H4a1.75 1.75 0 0 1-1.75-1.75V8.6c0-.967.784-1.75 1.75-1.75h2.513a.25.25 0 0 0 .169-.065zM21.47 8.47a.75.75 0 1 1 1.06 1.06L20.06 12l2.47 2.47a.75.75 0 1 1-1.06 1.06L19 13.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L17.94 12l-2.47-2.47a.75.75 0 1 1 1.06-1.06L19 10.94z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 26.5,
    height: 25.242,
    x: -0.75,
    y: 1.379,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_85682_23153"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_85682_23153",
    result: "effect2_dropShadow_85682_23153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_85682_23153",
    result: "shape"
  }))));
}
var IcVolumeoffFillWhiteshadow = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeoffFillWhiteshadow));

export { IcVolumeoffFillWhiteshadow as I };
